import React from "react";
import { motion } from "framer-motion";
import ReactGA from "react-ga4";
import { Box, Tabs, Tab, styled, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import TicketListPage from "../ticket_list_page"; /*this is for release 2*/

import Topics from "./components/topics";

import HomepageBanner from "./components/homepage_banner";
import * as workpalJS from "@workpal-build/workpaljs";
import { useDispatch, useSelector } from "react-redux";
import { storeLandingTab } from "../../state/action_creators";
import { Link } from "react-router-dom";

const LandingPage = () => {
  const theme = useTheme();
  const initialTab = useSelector((state) => state.tabs);
  const userapi = useSelector((state) => state.userapi);

  const [tabValue, setTabValue] = React.useState(initialTab);

  const dispatch = useDispatch();

  const onTabClick = (tabName) => {
    ReactGA.gtag("event", `Tap ${tabName} tab`, {
      sessionIdCustom: userapi.sessionID,
      userId: userapi.userSysId,
      orgID: !userapi.orgId ? 0 : userapi.orgId,
      agency: userapi.agency,
      channel: "Mobile",
      timestamp: Date(),
    });
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    dispatch(storeLandingTab(newValue));
  }; /*this is for release 2*/

  //Tabs css
  /*this is for release 2*/
  const StyledTabs = styled((props) => (
    <Tabs
      {...props}
      TabIndicatorProps={{
        children: <span className="MuiTabs-indicatorSpan" />,
      }}
    />
  ))({
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
    },
    "& .MuiTabs-indicatorSpan": {
      maxWidth: 60,
      width: "100%",
      backgroundColor: "#376EEE",
    },
    backgroundColor: "white",
    borderBottom: "1px solid #D0D0D0",
  });

  const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      textTransform: "none",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: 16,
      marginRight: theme.spacing(1),
      color: "#757575",
      "&.Mui-selected": {
        color: "#376EEE",
        fontWeight: 700,
      },
      "&.Mui-focusVisible": {
        backgroundColor: "rgba(100, 95, 228, 0.32)",
      },
    })
  );

  return (
    <motion.div>
      <HomepageBanner />
      {/* <Link
        to={`/report_incident_form/e1456626341036106d55d949501fea2e/ad456626341036106d55d949501fea2e?src=otherminiapp`}
      >
        tab me
      </Link> */}

      <StyledTabs
        value={tabValue}
        onChange={handleChange}
        indicatorColor="secondary"
        variant="fullWidth"
        aria-label="full width tabs example"
        style={{ position: "sticky", top: 0, zIndex: 10 }}
      >
        <StyledTab
          label="Topics"
          onClick={() => onTabClick("Topics")}
          {...a11yProps(0)}
        />
        <StyledTab
          label="Cases"
          onClick={() => onTabClick("Cases")}
          {...a11yProps(1)}
        />
      </StyledTabs>

      <TabPanel value={tabValue} index={0} dir={theme.direction}>
        <Topics />
      </TabPanel>
      <TabPanel value={tabValue} index={1} dir={theme.direction}>
        <TicketListPage />
      </TabPanel>
    </motion.div>
  );
};
export default LandingPage;

// STYLED TABS FUNCTIONS
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/*this is for release 2*/
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
